/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section, Slide } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';
import SelectConfiguration from 'components/selectConfiguration';
import SelectDeviceRole from 'components/selectDeviceRole';

import htmlSlide from '../../baseSlides/htmlSlide';
import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileTechPrep from './tech_prep.md';
import markdownFileTechPrepfr_CA from './tech_prep.fr_CA.md';

const techPrepMd = i18nData({
  en: new MarkdownScript(markdownFileTechPrep),
  fr_CA: new MarkdownScript(markdownFileTechPrepfr_CA)
});

function techPrepWizard ({ regionData, i18n }) {
  return htmlSlide({
    id: 'tech-prep-wizard',
    html: i18n(techPrepMd).getSectionAsHtml('Tech Prep Wizard', false, regionData)
  });
}

function twoDeviceIntro ({ regionData, i18n }) {
  return htmlSlide({
    id: 'two-device-intro',
    html: i18n(techPrepMd).getSectionAsHtml('Two Device Intro', false, regionData)
  });
}

function selectConfiguration () {
  return (
    <Slide
        id="configuration"
        textColor="white">
      <SelectConfiguration />
    </Slide>
  );
}

function connectingRemote ({ configuration, regionData, i18n }) {
  if (configuration === 'dualScreen') {
    return htmlSlide({
      id: 'connecting-remote',
      html: i18n(techPrepMd).getSectionAsHtml('Connecting Remote', false, regionData)
    });
  } else {
    return null;
  }
}

function selectDeviceRole (configuration) {
  if (configuration === 'dualScreen') {
    return (
      <Slide
          id="device-role"
          textColor="white">
        <SelectDeviceRole />
      </Slide>
    );
  } else {
    return null;
  }
}

function techCheckIntro ({ regionData, i18n }) {
  return htmlSlide({
    id: 'tech-check-intro',
    html: i18n(techPrepMd).getSectionAsHtml('Tech Check Intro', false, regionData)
  });
}

function techCheckVideo ({ regionData, i18n }) {
  return videoSlide({
    id: 'tech-check-video',
    youTubeId: i18n(techPrepMd).getSectionMetadata('Tech Check Video', 'YouTube', regionData)
  });
}

function levelPrep ({ configuration, regionData, i18n }) {
  return (

    <Section id="prep">

      {/* Tech Prep Wizard */}
      {techPrepWizard({ regionData, i18n })}

      {/* Two Device Intro */}
      {twoDeviceIntro({ regionData, i18n })}

      {/* Select Configuration */}
      {selectConfiguration()}

      {/* Connecting Remote Instructions */}
      {connectingRemote({ configuration, regionData, i18n })}

      {/* Select Device Role */}
      {selectDeviceRole(configuration)}

      {/* Tech Check Intro */}
      {techCheckIntro({ regionData, i18n })}

      {/* Tech Check Video */}
      {techCheckVideo({ regionData, i18n })}

      {/* Start Level */}

    </Section>
  );
}

function levelCompletedPrep ({ configuration, regionData, i18n }) {
  return (

    <Section id="prep">

      {/* Select Configuration */}
      {selectConfiguration()}

      {/* Connecting Remote */}
      {connectingRemote({ configuration, regionData, i18n })}

      {/* Select Device Role */}
      {selectDeviceRole(configuration)}

    </Section>
  );
}

function prepSection ({ level, configuration, regionData, i18n }) {
  switch (level) {
  case '1':
    return levelPrep({ configuration, regionData, i18n });
  case '2':
    return levelPrep({ configuration, regionData, i18n });
  case '3':
    return levelPrep({ configuration, regionData, i18n });
  case '4':
    return levelPrep({ configuration, regionData, i18n });
  case 'completed':
    return levelCompletedPrep({ configuration, regionData, i18n });
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default prepSection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/00_prep/prepSection.jsx